import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'crg-pagenotfound',
  templateUrl: './pagenotfound.component.html',
  styleUrls: ['./pagenotfound.component.scss']
})
export class PagenotfoundComponent implements OnInit {
  title = 'Shezi Carports';
  constructor() {
  }

  ngOnInit() {
  }
}
